export const mergeChangelogs = (matrix, frontendVersion, backendVersion) => {
  const backendChangelog =
    matrix?.backendVersions?.find((v) => v.version === backendVersion)?.changelog || [];
  const frontendChangelog =
    matrix?.frontendVersions?.find((v) => v.version === frontendVersion)?.changelog || [];

  return [...frontendChangelog, ...backendChangelog].filter(
    (item) => item?.title || item?.description || item?.body,
  );
};
